import * as React from 'react'
import { default as MuiDivider, DividerProps } from '@mui/material/Divider'

const Divider: React.FC<React.PropsWithChildren<DividerProps>> = (props) => {
  return <MuiDivider {...props} />
}

export default Divider
